<template>
    <div id="mysidebar" class="w-11/12">
        <div class="flex justify-center card-background">
            <vx-card class="xl:w-full lg:w-8/12 md:w-full shadow-lg custom-height px-4">
                <action-bar class="action-bar">
                    <template v-slot:left>
                        <vx-action-icon
                            :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'"
                            @click="navBack"
                        >
                        </vx-action-icon>
                        <h2 class="ml-5">{{ details.id ? 'Edit Author' : 'Create Author' }}</h2>
                    </template>
                </action-bar>
                <form ref="form" @submit.prevent="saveAuthor" class="">
                    <div class="flex justify-evenly mt-5">
                        <div class="w-6/12 px-2">
                            <div class="w-full">
                                <vx-input
                                    label="First Name"
                                    name="First name"
                                    :rules="['required']"
                                    v-model="details.firstName"
                                    class="w-full mt-2"
                                    placeholder="Enter author's first name"
                                />

                                <vx-input
                                    label="Last Name"
                                    name="Last name"
                                    :rules="['required']"
                                    v-model="details.lastName"
                                    class="w-full mt-2"
                                    placeholder="Enter author's last name"
                                />

                                <vx-input
                                    label="Position"
                                    name="Position"
                                    :rules="['required']"
                                    v-model="details.position"
                                    class="w-full mt-2"
                                    placeholder="Enter author's position, e.g. Meditation teacher"
                                />

                                <vx-input
                                    label="Organisation"
                                    name="Organisation"
                                    :rules="['required']"
                                    v-model="details.organisation"
                                    class="w-full mt-2"
                                    placeholder="Enter author's Organisation, e.g. CompNow"
                                />

                                <vx-textarea
                                    label="Author Blurb"
                                    v-model="details.blurb"
                                    rows="3"
                                    class="w-full -mt-1"
                                ></vx-textarea>

                                <vx-calendar-input
                                    label="Onboarding Date"
                                    name="Onboarding Date"
                                    :rules="['required']"
                                    class="w-full mt-2"
                                    v-model="details.onBoardDate"
                                ></vx-calendar-input>

                                <vx-resource-set
                                    :resources="profileImage"
                                    allow-create
                                    allow-delete
                                    :limit="1"
                                    read-only
                                    justify="center"
                                    text="Upload Profile Image"
                                    class="mr-2 imageUploaderText"
                                    @uploaded="setProfileImage"
                                >
                                </vx-resource-set>
                            </div>
                        </div>
                    </div>

                    <div class="flex justify-center mt-10 relative">
                        <button type="submit" class="create w-1/6 h-12 z-50">
                            {{ authorID ? 'Save' : 'Create' }}
                        </button>
                    </div>
                </form>
            </vx-card>
        </div>
    </div>
</template>

<script>
import ActionBar from '@/components/custom/ActionBar'
import { mapParams } from '@/plugins/mappers'

export default {
    name: 'create-author',
    components: {
        ActionBar
    },
    computed: {
        ...mapParams({
            url_id: 'author_id'
        }),
        authorID() {
            return this.url_id
        }
    },
    props: {},
    data() {
        return {
            loading: false,
            details: {
                firstName: null,
                lastName: null,
                position: null,
                organisation: null,
                blurb: null,
                onBoardDate: new Date()
            },
            profileImage: []
        }
    },
    methods: {
        async saveAuthor() {
            this.loading = true
            if (await this.validate()) {
                try {
                    var response
                    if (this.details.id) {
                        //update
                        response = await this.$api.author.updateAuthor(this.details)
                        await this.saveProfileImage(response.id)

                        this.notifySuccess(
                            'Updated successfully',
                            'Author Updated successfully.',
                            5000
                        )
                    } else {
                        //create
                        response = await this.$api.author.createAuthor(this.details)
                        await this.saveProfileImage(response.id)

                        this.notifySuccess(
                            'Created successfully',
                            'Author created successfully.',
                            5000
                        )
                        this.$router.replace(`/authors/${response.id}`)
                    }
                } catch (err) {
                    console.error(err)

                    this.notifyError('Error', `Error message: ${err}`, 5000)
                } finally {
                    this.loading = false
                }
            }
        },
        setProfileImage(newImage) {
            this.$set(this.profileImage, 0, newImage)
        },
        async saveProfileImage(id) {
            if (this.profileImage.any() && this.profileImage[0].file) {
                await this.$api.author.updateProfileImage(id, this.profileImage[0])
            }
        },
        navBack() {
            this.$router.go(-1)
        },
        async getDetails() {
            if (this.authorID) {
                this.loading = true
                try {
                    this.details = await this.$api.author.fetchAuthor(this.authorID)

                    if (this.details.profileImage) {
                        this.setProfileImage(this.details.profileImage)
                    }
                } catch (err) {
                    console.error(err)
                    this.notifyError(
                        'Communication Error',
                        'Could not retrieve author details from server, please check your connection and try again.',
                        2000
                    )
                } finally {
                    this.loading = false
                }
            }
        }
    },
    watch: {
        authorID: {
            handler: async function (author_id) {
                if (author_id) {
                    await this.getDetails()
                }
            },
            immediate: true
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;600;700;800&family=Playfair+Display:wght@400;500;600;700;800&display=swap');
.croc {
    position: absolute;
    left: 10px;
    bottom: -40px;
}
.card-background {
    background: transparent;
    height: 100%;
}
.custom-height {
    min-height: 540px;
}
.create {
    border: none;
    border-radius: 50px;
    background-color: #9dd6cd;
    color: #fff;
    font-size: 1.5rem;
    box-shadow: 0px 2px 6px 0.5px #bebebe;
    cursor: pointer;
    font-family: 'Playfair Display', serif;
    letter-spacing: 2px;
}
a {
    font-size: 1rem;
}
p {
    color: #949c9c;
}
li {
    color: #949c9c;
    font-size: 1.1rem;
}

.imageUploaderText {
    font-size: 0.85rem;
}
</style>
